module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/products/single-product/images/product-images.component.css
// module id = ./src/app/products/single-product/images/product-images.component.css
// module chunks = main